import { render, staticRenderFns } from "./orderReview.vue?vue&type=template&id=007d38ea&"
import script from "./orderReview.vue?vue&type=script&lang=js&"
export * from "./orderReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports